enum TaskClientFeedbackNegativeType {
    CREATIVITY = 'creativity',
    SPEED = 'speed',
    QUALITY = 'quality',
    COMMUNICATION = 'communication',
}

export default TaskClientFeedbackNegativeType;
